import React from 'react'

import styles from './Concept.module.scss'
import Title from '../images/svg/head_concept.svg'
import bg from '../images/photo_concept.jpg'

const Concept = () => (
    <section name="concept" className={styles.wrapper}>
        <div className={styles.bg}>
            <img src={bg} alt=""/>
        </div>
        <div className={styles.container}>
            <h2 className="sr-only">コンセプト</h2>
            <div className={styles.head}>
                <Title />
            </div>
            <h3 className={styles.catch}>
                小さなハッピーが<br />
                大きなサニーライフを
            </h3>
            <p className={styles.desc}>
                小さなハッピーを積み重ねると、大きな幸せが溢れる、新しい世の中ができる。わたしたち株式会社Happy Sunnyは、常に「笑顔」と「幸せ」のあるクリエイティブやプランニングを創り続けています。世の中に新しいチャレンジをしながら、今までにないサービスをお客様と一緒に生み出します。
                <span>代表取締役　井上 翼</span>
            </p>
        </div>
    </section>
)

export default Concept;
